<div>
  <div class="header-container">
    <h4 *ngIf="!importComplete" class="header-text">
      Import <small *ngIf="modalTitle">{{uploadType}}for {{ modalTitle }}</small>
    </h4>
    <h4 *ngIf="importComplete" class="header-text">Success!</h4>
    <i class="fas fa-times close-button" (click)="dismissModal()"></i>
  </div>

  <div>
    <div *ngIf="!importComplete">
      <div class="modal-container">
        <ul
          ngbNav
          #nav="ngbNav"
          [(activeId)]="activeTab"
          class="nav-pills tab-set"
        >
          <li ngbNavItem="file" class="file">
            <a ngbNavLink
              >File&nbsp;
              <i *ngIf="!this.fileQueue[0]?.id" class="fal fa-angle-right"></i>
              <i
                *ngIf="this.fileQueue[0]?.id"
                class="fas fa-check"
                [ngClass]="{
                  'black-check': activeTabNavIndex != 0,
                  'white-check': activeTabNavIndex == 0
                }"
              >
              </i>
            </a>

            <ng-template ngbNavContent>
              <app-file-upload
                [allowedMimeTypes]="allowedMimeTypes"
                [currentFileCount]="fileQueue.length"
                (handleFileSelected)="onFileSelected($event)"
              >
                <h4 class="component-header">
                  1. Upload
                  <small>Your {{ importEntityFields?.entityMessage }}</small>
                </h4>
                <app-file-status-list
                  [fileList]="fileQueue"
                ></app-file-status-list>
              </app-file-upload>
            </ng-template>
          </li>
          <li ngbNavItem="tab" class="tab">
            <a ngbNavLink
              >Tabs&nbsp;<i
                *ngIf="!selectedWorksheet || !worksheets.length"
                class="fal fa-angle-right"
              ></i>
              <i
                *ngIf="selectedWorksheet && worksheets.length"
                class="fas fa-check"
                [ngClass]="{
                  'black-check': activeTabNavIndex != 1,
                  'white-check': activeTabNavIndex == 1
                }"
              >
              </i>
            </a>
            <ng-template ngbNavContent>
              <app-worksheet-tabs-content
                [worksheets]="worksheets"
                [selectedWorksheet]="selectedWorksheet"
                (updatedWorksheet)="updateSelectedWorksheet($event)"
              >
              </app-worksheet-tabs-content>
            </ng-template>
          </li>
          <li ngbNavItem="columns" class="column">
            <a ngbNavLink
              >Columns
              <i
                *ngIf="!hasMappingForRequiredFields()"
                class="fal fa-angle-right"
              ></i>
              <i
                *ngIf="hasMappingForRequiredFields()"
                class="fas fa-check"
                [ngClass]="{
                  'black-check': activeTabNavIndex != 2,
                  'white-check': activeTabNavIndex == 2
                }"
              >
              </i>
            </a>
            <ng-template ngbNavContent>
              <app-columns-tab-content
                [selectedHeaderRowIndex]="selectedHeaderRowIndex"
                [mappedColumnFields]="mappedColumnFields"
                [assignableFields]="assignableFields"
                (updateMappedColumnFields)="updateMappedColumnFields($event)"
                (updateSelectedHeaderRowIndex)="
                  updateSelectedHeaderRowIndex($event)
                "
                [headerColumnRows]="headerColumnRows"
                [isColumnsLoading]="isColumnsLoading"
                [theme]="theme"
              >
              </app-columns-tab-content>
            </ng-template>
          </li>
          <li ngbNavItem="summary" class="summary">
            <a ngbNavLink
              >Summary&nbsp;
              <i *ngIf="!hasCrossesSummaryData()" class="fal fa-angle-right"></i>
              <i
                *ngIf="hasCrossesSummaryData()"
                class="fas fa-check"
                [ngClass]="{
                  'black-check': activeTabNavIndex != 3,
                  'white-check': activeTabNavIndex == 3
                }"
              >
              </i>
            </a>

            <ng-template ngbNavContent>
              <app-summary-tab-content
                [hasSelectedFile]="!!getSelectedFileId()"
                [areColumnsMapped]="this.hasMappingForRequiredFields()"
                [analysisSummaryData]="analysisSummaryData"
                [isAnalysisLoading]="isAnalysisLoading"
                [featureFlags]="featureFlags"
                (loadAnalysis)="getImportCrossesSummary()"
                [isSendForReviewAllowed]="isSendForReviewAllowed"
                [sentForReviewCount]="sentForReviewCount"
                (submitForReview)="submitForReview()"
                [uploadTypeLabel]="importEntityFields?.uploadTypeLabel"
                [baseApiUrl]="baseApiUrl"
              ></app-summary-tab-content>
            </ng-template>
          </li>
        </ul>
      </div>
      <div [ngbNavOutlet]="nav" class="child"></div>
    </div>

    <div class="success-container" *ngIf="importComplete">
      <div>
        <h5>
          <i id="success-check" class="fas fa-check"></i> Imported
          <small>{{ analysisSummaryData?.recordMatchedCount || 0 }}</small>
          products
        </h5>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="d-flex">
      <!-- Review button - only available after import. -->
      <div
        *ngIf="canShowButton('send-for-review') && isSendForReviewAllowed"
        [ngbPopover]="
          sentForReviewCount != null && sentForReviewCount >= 0
            ? sentForReviewCount + ' Products Sent for Review.'
            : ''
        "
        [openDelay]="1000"
        [autoClose]="false"
      >
        <button
          data-test-selector="send-for-review-button"
          class="btn send-for-review-button d-flex"
          [disabled]="
            sentForReviewCount != null || !analysisSummaryData?.sendForReviewCount
          "
          (click)="submitForReview()"
        >
          Send for Review
          <i *ngIf="sentForReviewCount !== -1" class="fa fa-share-square"></i>
          <ng-container *ngIf="sentForReviewCount === -1">
            <span
              *appLoadingIndicator="{
                show: true,
                showBackdrop: false,
                fullPage: false,
                message: ''
              }"
            ></span>
          </ng-container>
        </button>
      </div>
    </div>

    <div class="d-flex">
      <button
        *ngIf="canShowButton('previous')"
        data-test-selector="previous-button"
        class="btn btn-outline-secondary"
        (click)="previousTab()"
      >
        <i class="fal fa-angle-left"></i> Previous
      </button>

      <button
        *ngIf="canShowButton('next')"
        data-test-selector="next-button"
        class="btn btn-primary ms-4"
        (click)="nextTab()"
      >
        Next <i class="fal fa-angle-right"></i>
      </button>

      <button
        *ngIf="canShowButton('import')"
        data-test-selector="import-button"
        [disabled]="!canImport()"
        class="btn btn-secondary ms-4"
        (click)="import()"
      >
        <span *ngIf="isImportLoading">
          <span
            *appLoadingIndicator="{
              show: true,
              showBackdrop: false,
              fullPage: false,
              message: 'Import'
            }"
          ></span>
        </span>
        <span *ngIf="!isImportLoading">Import</span>
      </button>

      <!--
        After Import
      -->
      <button
        *ngIf="canShowButton('view-rejects')"
        data-test-selector="view-rejected-button"
        (click)="download()"
        [disabled]="!this.analysisSummaryData?.downloadUrl"
        class="btn view-rejects-button"
      >
        <span *ngIf="!downloading">
          <i class="fas fa-download"></i> View Rejected
        </span>
        <span
          *appLoadingIndicator="{
            show: downloading,
            showBackdrop: false,
            fullPage: false,
            message: 'Downloading...'
          }"
        ></span>
      </button>

      <button
        *ngIf="canShowButton('view-products')"
        data-test-selector="view-products-button"
        class="btn view-products-button ms-4"
        (click)="closeModal()"
      >
        View Products
      </button>
    </div>
  </div>
</div>
